var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:#fff;stroke:#666;stroke-miterlimit:10}.cls-2{fill:none;stroke-linecap:square}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 14.211,
    height: 14.211,
    className: "cls-1",
    rx: 1,
    transform: "translate(0 3.789)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    width: 14.211,
    height: 14.211,
    className: "cls-1",
    "data-name": "Rectangle",
    rx: 1,
    transform: "translate(1.895 1.895)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    width: 14.211,
    height: 14.211,
    className: "cls-1",
    "data-name": "Rectangle",
    rx: 1,
    transform: "translate(3.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2_Copy",
    d: "M.474.474h3.789",
    className: "cls-2",
    "data-name": "Line 2 Copy",
    transform: "translate(5.684 5.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2_Copy_3",
    d: "M0 .474h9",
    className: "cls-2",
    "data-name": "Line 2 Copy 3",
    transform: "translate(6.158 10.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2_Copy_2",
    d: "M0 .474h9",
    className: "cls-2",
    "data-name": "Line 2 Copy 2",
    transform: "translate(6.158 8.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M0 .474h3.789",
    className: "cls-2",
    "data-name": "Line 2",
    transform: "translate(6.158 2.368)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.6bef479f112a1c386ec29de067e260ef.svg";
export { ForwardRef as ReactComponent };